
    /**
     * @Author: sunchao
     * @Date:   2019/5/27 11:13
     */
    import {Component, Watch, Vue} from "vue-property-decorator";
    import Step from "@/components/Step.vue";
    import {setToken,getToken} from "@/util/auth";
    import {getTokenUser} from "../api/index";

    import config from "../../public/js/config";



    @Component({
        components: {
            Step,
        },
    })
    export default class Guide extends Vue {
        private active: number = 0;
        private checked: boolean = true;
        private buttonDisabled: boolean = false;
        private redirect: any = "";

        @Watch("checked")
        public handleChecked(val: boolean, oldVal: boolean): void {
            val === true ? this.buttonDisabled = false : this.buttonDisabled = true;
        }
        private created() {
            if(document.referrer==''){
                window.location.href = config.wechatBase + "#/userCenter";
            }
            // const userGuid: any = this.$route.query.guid ? this.$route.query.guid : null;
            const token: any = this.$route.query.token ? this.$route.query.token : null;

            this.redirect = this.$route.query.redirect;
            console.log(this.redirect)
            setToken("access_token", token);
            window.sessionStorage.setItem("access_token", token);
            if (this.redirect){
                window.sessionStorage.setItem("redirect", this.redirect);
            }
        }





        /**
         * 查看用户协议
         */
        private viewUserAgreement(): void {
            this.$router.push({path: `/about`});
        }

        /**
         * 查看用户信息
         */
        private viewUserInfo(): void {
            this.$router.push({path: `/info`});
        }
    }
